module.exports = __webpack_public_path__ + "static/img/nodata_error.6ee53ecc.png";